import "popper.js";
import "bootstrap";
import Swiper from "swiper";

(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.metascore_theme = {
    attach: function (context) {
      /*
       * Fullscreen links
       */
      once(
        "metascore-theme-fullscreen",
        "[data-behavior~=fullscreen]",
        context
      ).forEach(function (el) {
        const $link = $(el);
        const guide = $link.data("guide");
        const adaptSize = $link.data("adaptsize");
        const allowUpscaling = $link.data("allowupscaling");

        const iframe = document.querySelector(`iframe#${guide}`);
        if (!iframe) return;

        new metaScore.API(iframe, (api) => {
          $link.click((event) => {
            const onFullscreenChange = () => {
              if (document.fullscreenElement) {
                api.responsive(
                  typeof adaptSize !== "undefined",
                  typeof allowUpscaling !== "undefined"
                );
              } else {
                document.removeEventListener(
                  "fullscreenchange",
                  onFullscreenChange
                );
                api.responsive(true, false);
              }
            };
            api.enterFullscreen();

            document.addEventListener("fullscreenchange", onFullscreenChange);

            event.preventDefault();
          });
        });
      });

      /*
       * Swipers
       */
      once(
        "metascore-theme-swiper",
        "[data-behavior~=swiper]",
        context
      ).forEach(function (el) {
        const $container = $(el);
        const slidesPerView = $container.data("slides-per-view");

        new Swiper($container, {
          loop: $container.data("loop"),
          spaceBetween: 15,
          navigation: {
            nextEl: $container.siblings(".swiper-button-next"),
            prevEl: $container.siblings(".swiper-button-prev"),
          },
          pagination: {
            el: $container.siblings(".swiper-pagination"),
            clickable: true,
          },
          breakpoints: {
            1: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: slidesPerView,
            },
          },
        });
      });

      /*
       * Class togglers
       */
      once(
        "metascore-theme-toggle-class",
        "[data-behavior~=toggle-class]",
        context
      ).forEach(function (el) {
        $(el).click(function (event) {
          const CssClass = el.dataset.class;

          let $context = null;
          if ("context" in el.dataset) {
            switch (el.dataset.context) {
              case "this":
                $context = el;
                break;

              case "parent":
                $context = $(el).parent();
                break;

              case "closest":
                $context = $(el).closest(el.dataset.contextSelector);
                break;
            }
          }

          const $target = $(el.dataset.target, $context);

          $target.toggleClass(CssClass);

          event.preventDefault();
        });
      });

      /*
       * Popovers
       */
      once(
        "metascore-theme-popover",
        "[data-toggle='popover']",
        context
      ).forEach(function (el) {
        const options = {
          delay: { show: 0, hide: 100 },
        };
        const $el = $(el);

        const $content = $("> .popover-content", el);
        if ($content.length > 0) {
          options.content = $content;
        }

        const $container = $("> .popover-container", el);
        if ($container.length > 0) {
          options.container = $container;
        }

        $el.popover(options).addClass("popover-ready");
      });

      /*
       * Clipboard
       */
      once(
        "metascore-theme-clipboard",
        "[data-behavior~=clipboard]",
        context
      ).forEach(function (el) {
        const hover_tooltip = Drupal.t("Copy to clipboard");
        const click_tooltip = Drupal.t("Copied");
        let content = hover_tooltip;

        const $wrapper = $('<div class="clipboard-wrapper"></div>')
          .insertAfter(el)
          .append(el);

        const $btn = $(
          '<button type="button" class="btn clipboard"><i class="icon-clipboard"></i></button>'
        )
          .appendTo($wrapper)
          .popover({
            content: function () {
              return content;
            },
            placement: "top",
            trigger: "hover",
          })
          .click(function () {
            el.select();
            el.focus();
            document.execCommand("copy");
            content = click_tooltip;
            $btn.popover("show");

            setTimeout(function () {
              $btn.popover("hide");
              content = hover_tooltip;
            }, 1000);
          });
      });

      /*
       * Modals
       */
      once("metascore-theme-modal", ".modal.show", context).forEach(function (
        el
      ) {
        $(el).modal();
      });

      /*
       * Ajax Modal
       */
      let spinner = '<div class="text-center py-1">';
      spinner += '<div class="spinner-border" role="status">';
      spinner += '<span class="sr-only">' + Drupal.t("Loading...") + "</span>";
      spinner += "</div>";
      spinner += "</div>";

      once(
        "metascore-theme-ajax-modal",
        "a[data-behavior~=ajax-modal]",
        context
      ).forEach(function (index, el) {
        const $link = $(el);
        const $modal = $(".modal[data-name=ajax-modal]");
        const $modal_dialog = $(".modal-dialog", $modal);
        const $modal_content = $(".modal-content", $modal);

        const ajax = Drupal.ajax({
          url: $link.attr("href"),
          event: "click",
          progress: false,
          element: el,
          method: "html",
          submit: {
            js: true,
            ajax_modal: true,
          },
          beforeSend: function (xmlhttprequest) {
            $modal.on("hidden.bs.modal", function () {
              // Abort the request if the modal was closed.
              xmlhttprequest.abort();
              // Reset the modal's contents.
              $modal_content.empty();
            });

            $modal_content.html(spinner);
            $modal_dialog.toggleClass(
              "modal-dialog-centered",
              typeof el.dataset.modalFixed === "undefined"
            );
            $modal.modal("show");
          },
        });
        ajax.wrapper = $modal_content;
      });

      // Override Ajax throbber.
      Drupal.theme.ajaxProgressThrobber = function (message) {
        const messageMarkup =
          typeof message === "string"
            ? Drupal.theme("ajaxProgressMessage", message)
            : "";
        const throbber =
          '<div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>';
        return (
          '<div class="ajax-progress ajax-progress-throbber d-flex align-items-center">' +
          throbber +
          messageMarkup +
          "</div>"
        );
      };
      Drupal.Ajax.prototype.setProgressIndicatorThrobber = function () {
        const $element = $(this.element);
        this.progress.element = $(
          Drupal.theme("ajaxProgressThrobber", this.progress.message)
        );
        if ($element.is("button")) {
          $(this.element).prepend(this.progress.element);
        } else {
          const $input_group = $(this.element).parent(".input-group");
          if ($input_group.length > 0) {
            $input_group.append(this.progress.element);
          } else {
            $(this.element).after(this.progress.element);
          }
        }
      };
    },
  };
})(jQuery, Drupal, once);
